import {
    DELIVERY_OPTION_TYPES_FETCHING,
    DELIVERY_OPTION_TYPES_FETCHING_SUCCESS,
    DELIVERY_OPTION_TYPES_FETCHING_FAILURE
} from '../actions/types'


const INITIAL_STATE = {
    fetching: false,
    items: []
}

const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case DELIVERY_OPTION_TYPES_FETCHING:
            return {
                ...state,
                fetching: true,
            }

        case DELIVERY_OPTION_TYPES_FETCHING_SUCCESS:
            return {
                ...state,
                fetching: false,
                items: prepareItems(action.payload)
            }

        case DELIVERY_OPTION_TYPES_FETCHING_FAILURE:
            return {
                ...state,
                fetching: false,
            }

        default:
            return state
    }
}

const prepareItems = (items) => {
    return items.filter(({isActive}) => isActive).map(({ id, name, isActive }) => ({id, name, isActive}))
}

export default reducer
